import React from 'react';
import { Phone, FileText, MessageSquareQuote } from 'lucide-react';
import { useDrawers } from '../../contexts/DrawerContext';
export function MobileActionBar() {
  const {
    openQuote,
    openUpload
  } = useDrawers();
  return <div className="fixed bottom-0 left-0 right-0 z-40 md:hidden p-3" data-id="element-502">
      <div className="flex items-stretch gap-2 rounded-2xl bg-ink/95 backdrop-blur shadow-warm p-1.5" data-id="element-503">
        <a href="tel:+61386172600" className="flex-1 flex flex-col items-center justify-center gap-0.5 py-2 min-h-[48px] rounded-xl text-cream hover:bg-white/10 transition-colors" data-id="element-504">
          <Phone className="w-5 h-5" data-id="element-505" />
          <span className="text-[10px] font-semibold uppercase tracking-wide" data-id="element-506">
            Call
          </span>
        </a>
        <button onClick={openUpload} className="flex-1 flex flex-col items-center justify-center gap-0.5 py-2 min-h-[48px] rounded-xl text-cream hover:bg-white/10 transition-colors" data-id="element-507">
          <FileText className="w-5 h-5" data-id="element-508" />
          <span className="text-[10px] font-semibold uppercase tracking-wide" data-id="element-509">
            Upload
          </span>
        </button>
        <button onClick={openQuote} className="flex-1 flex flex-col items-center justify-center gap-0.5 py-2 min-h-[48px] rounded-xl bg-accent text-white hover:bg-accent-dark transition-colors" data-id="element-510">
          <MessageSquareQuote className="w-5 h-5" data-id="element-511" />
          <span className="text-[10px] font-semibold uppercase tracking-wide" data-id="element-512">
            Quote
          </span>
        </button>
      </div>
    </div>;
}